import { StyleSheet } from "react-native";
import { COLORS } from "../../../../Diathrive/src/utils/Constants";

import CommonStyles from "../../../../Diathrive/src/utils/CommonStyles";
const styles = StyleSheet.create({
  container: {
    ...CommonStyles.full_flex,
    ...CommonStyles.flex_display,
  },
  uniqueIdForm: {
    ...CommonStyles.full_flex,
    ...CommonStyles.pl_56,
    ...CommonStyles.pr_56,
  },
  previewImage: {
    ...CommonStyles.half_width,
    ...CommonStyles.full_height,
    backgroundColor: COLORS.greyBackground,
  },
  formContainer: {
    height: "calc(100% - 212px)", // 212 is height of header + footer
  },
});

export default styles;
